import React, { useContext, useEffect, useState } from "react";
import * as SockJS from "sockjs-client";
import * as Stomp from "stompjs";
import useAuth from "../hooks/useAuth";

const SOCKET_PORT =
  window.location.hostname === "localhost" ? 8080 : window.location.port;
const SERVER = `${window.location.protocol}//${window.location.hostname}:${SOCKET_PORT}/ws/`;

const SocketContext = React.createContext();

export function useSocket() {
  return useContext(SocketContext);
}
export function SocketProvider({ children }) {
  const { auth } = useAuth();
  const [socket, setSocket] = useState();
  const [isConnected, setIsConnected] = useState(false);

  useEffect(() => {
    if (auth?.user) {
      console.log("Connecting to socket...");
      const newSocket = new SockJS(SERVER);
      const newStompClient = Stomp.over(newSocket);
      newStompClient.connect({}, (frame) => {
        if (frame && frame.command?.toLowerCase() === "connected") {
          setIsConnected(true);
        }
      });
      newStompClient.debug = null;
      setSocket(newStompClient);

      return () => {
        try {
          if (newStompClient?.connected) {
            console.log("Disconnecting socket...");
            newStompClient?.disconnect();
            newSocket?.close();
          }
        } catch (e) {
          console.log(e);
        }
      };
    }
  }, [auth]);

  const value = {
    socket,
    isConnected,
  };

  return (
    <SocketContext.Provider value={value}>{children}</SocketContext.Provider>
  );
}
